module.exports = __webpack_public_path__ + "static/roentgen.aca07306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/header/roentgen.jpg
// module id = 463
// module chunks = 40757032301952